import './project.scss';
import * as React from 'react';
import { BlogPostCard } from '../../components/blog/blogPost';
import { Breadcrumbs } from '../../components/layout/breadcrumbs';
import FullScreenSection from '../../components/layout/fullScreenSection';
import { PageHero } from '../../components/layout/pageHero';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { VideoBackground } from '../../components/layout/videoBackground';
import { View } from '../../components/layout/view';
import { LazyCosmosImage } from '../../components/media/cosmosImage';
import { ImageGallery } from '../../components/media/imageGallery';
import { MediaCard } from '../../components/media/mediaCard';
import { MoreProjects } from '../../components/project/moreProjects';
import { ProjectLinks } from '../../components/project/projectLinks';
import { ProjectListItemCarousel } from '../../components/project/projectListItemCarousel';
import ProjectTags from '../../components/project/projectTags';
import { QuotesCarousel } from '../../components/quotes/quotesCarousel';
import { RMMarkdown } from '../../components/RMMarkdown';
import { ShareButtons } from '../../components/shareButton';
import { icons } from '../../content/icons';
import { RoutePaths } from '../../routes';
import { ColourUtils } from '../../utils/colours';
import { EnvironmentUtils } from '../../utils/environment';
import { ImageUtils } from '../../utils/image';
import { StringUtils } from '../../utils/string';
export const ProjectPage = ({ pageContext: { item: project, blogPosts, relatedProjects } }) => {
    const logoTicket = (project.client_logo_coloured?.[0] || project.client_logo?.[0])?.ticket;
    return (<View title={project.client_name} className="project" style={{ ['--client-colour']: project.client_brand_color }}>
      <PageHero>
        <FullScreenSection mini darkenBg={false} background={project.project_hero_video ? (<VideoBackground videoUrl={project.project_hero_video} videoPosterUrl={project.project_hero_video_poster}/>) : (project.project_cover_image !== undefined &&
        project.project_cover_image.length > 0 && (<div className="hero-video-replacement-image" style={{
        backgroundImage: `url(${ImageUtils.getCosmosAssetUrl(project.project_cover_image[0].ticket)})`,
    }}/>))}/>
      </PageHero>

      <Breadcrumbs crumbs={[
        { icon: icons.back, title: 'Projects', to: RoutePaths.projects.projects() },
        { title: StringUtils.truncate(project.client_name, 40) },
    ]}/>

      <div className="intro-section">
        {logoTicket ? <LazyCosmosImage className="logo" ticket={logoTicket} alt={`${project.client_name}'s logo`}/> : <h3>{project.client_name}</h3>}

        <p className="short-copy">{project.project_description_short}</p>
      </div>

      <div className="project-tags-wrapper">
        <p>what we did</p>
        <ProjectTags tags={project.project_types}/>
      </div>

      <div className="client-colour-section">
        <div className="who-are-they-section">
          <h2>Who are they?</h2>
          <p>{project.project_description_long}</p>
        </div>
      </div>

      {project.case_study_content && (<div className="project-content">
          <RMMarkdown>{project.case_study_content}</RMMarkdown>
        </div>)}

      <div className="client-colour-section">
        <QuotesCarousel quotes={project.client_quotes.map((quote) => ({
        quoteText: quote.quote_text,
        author: {
            name: quote.author_name,
            position: quote.author_position,
        },
        image: {
            alt: quote.author_name,
            ticket: quote.author_photo[0].ticket,
        },
    }))}/>
      </div>

      {!!project.image_gallery && !!project.image_gallery.length && (<ImageGallery images={project.image_gallery.map((image) => ({
        ticket: image.image[0].ticket,
        caption: image.caption,
    }))}/>)}

      {(project.vimeo_id || project.case_study_pdf?.[0]) && (<div className="other-media-section">
          {project.vimeo_id && <MediaCard vimeoId={project.vimeo_id} icon={icons.video} text={`Watch a video about ${project.client_name}`}/>}
          {project.case_study_pdf?.[0] && (<MediaCard downloadSrc={ImageUtils.cosmosAssetBaseUrl(project.case_study_pdf[0].ticket)} icon={icons.download} text="Download a PDF of this case study"/>)}
        </div>)}

      <hr />

      {!!blogPosts?.length && (<div className="related-blog-posts">
          <SectionTitle title="Recent Blog Posts on this Project"/>

          {blogPosts.map((blogPost) => (<BlogPostCard blogPost={blogPost} key={blogPost?.title}/>))}
        </div>)}

      {!!relatedProjects?.length && (<div className="related-projects">
          <SectionTitle title="Some Related Projects"/>

          <ProjectListItemCarousel projects={relatedProjects} analyticsId={`Related Projects (to ${project.client_name})`}/>
        </div>)}

      <MoreProjects />

      <ProjectLinks {...project} buttonVariant="darken-bg"/>

      <ShareButtons variant="white" url={!EnvironmentUtils.isSSR() && window.location.href} title={project.client_name} text={`Check out this project from Rocketmakers — ${project.client_name}`}/>

      <Footer />

      <BackToTop colour={project.client_brand_color}/>

      <ColourUtils.SelectionColourChange colour={project.client_brand_color} selector=".view.project .project-body *"/>
    </View>);
};
export default ProjectPage;
